var $ = require('../internals/export');
var bind = require('../internals/function-bind');

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.function.bind.js
// module id = 1067
// module chunks = 0